module.exports = __webpack_public_path__ + "img/webpack.b3e393a3.png";